import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches all tasks for a patient. */
export function useListPatientTasks(patientId: string) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['patient-tasks', patientId],
    queryFn: async () => {
      const response = await api.get('/tasks', { query: { patientId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.tasks
    },
  })
}
